/* Built In Imports */

/* External Imports */
import { Box, Flex, Heading } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
/* Configs */
import programStructureCardSt from '@ieo/Common/StyleData/ProgramStructureCardSt';

/* Styles */
/* Services */

/**
 * @param {String} lang
 * @param {Object} data
 * @returns {ReactElement} ProgramStructureCard
 */

const ProgramStructureCardV3 = ({ data, lang }) => {
  return (
    <Box
      pos="relative"
      mt={{ base: '20px', md: '0' }}
      mb={{ base: '40px', md: '60px' }}
      display="flex"
      justifyContent="center"
    >
      <Flex
        bg={`url(${data?.thumbnail?.url})`}
        width={{
          base: '97%',
          sm: '210px',
          md: '217px',
          xl: '235px',
        }}
        bgPos="top center"
        bgSize="cover"
        // justify="flex-end"
        bgRepeat="no-repeat"
        flexDir="column"
        height={{ base: '148px', sm: '244px', md: '205px', lg: '240px' }}
        pb="20px"
        borderRadius="10px"
        position="relative"
      >
        <Flex
          bg="white"
          w={{ base: '86%', sm: '80%', lg: '82%' }}
          maxW="86%"
          h={{ base: '50px', sm: '90px', md: '100px', lg: '82px' }}
          position="absolute"
          left="50%"
          transform="translateX(-50%)"
          bottom={{ base: '-28px', sm: '-45px', md: '-50px' }}
          flexDir="column"
          justifyContent="center"
          alignItems="center"
          boxShadow="12px 0 14px -10px #A45B0B, -12px 0 14px -10px #A45B0B, 0 2px 4px -2px white"
          px={{ base: 0, sm: '10px', md: '10px' }}
          borderRadius="4px"
          border="none"
          _after={{
            content: '""',
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: '-10px',
            height: '10px',
            bg: '#fff',
            pointerEvents: 'none',
            zIndex: 3,
          }}
        >
          <Heading
            px={{ base: 0.5, md: '0' }}
            as="h2"
            {...programStructureCardSt[lang].cardV3}
            fontSize={{ base: '13px', sm: '15px', md: '18.9px' }}
            textAlign="center"
            whiteSpace="normal"
            lineHeight={{ base: '13.37px', md: '21.37px' }}
            color={lang === 'ta' ? '#12166F' : '#7A6E4B'}
          >
            {data?.title}
          </Heading>
        </Flex>
      </Flex>
    </Box>
  );
};

export default ProgramStructureCardV3;
